import axios from "axios";

export class BaseApi {
  // public baseUrl = "https://78.39.234.226:4437/api";
  // public baseUrl = "http://toll.dehyarkurd.ir/api";
  public baseUrl = "https://hamlonaghlebaneh.ir/api";
   // public baseUrl = "https://localhost:5001/api";
  public version = "v1";
  public cancelTokenSource = axios.CancelToken.source();

  public handleCancelRequest = async () => {
    this.cancelTokenSource.cancel("Request was canceled");
  };
  public axiosInstance(auth: boolean = false) {
    let headers: any = {
      "Content-type": "application/json",
    };
    if (auth) {
      headers.Authorization = `Bearer ${localStorage.getItem("_t")}`;
    }

    return axios.create({
      baseURL: `${this.baseUrl}/${this.version}`,
      headers,
      cancelToken: this.cancelTokenSource.token,
    });
  }
}
